const tabs = [
    { label: 'News', value: 'news' },
    { label: 'Games', value: 'games' },
    { label: 'Saison', value: 'saison' },
    { label: 'Tickets', value: 'tickets' },
    { label: 'Business', value: 'business' },
];

export default tabs;
